module.exports = __webpack_public_path__ + "img/logo.0bdb108b.png";